<template>
    <div class="compo-form-item" :class="{minimum : minimumHas}">
        <BtnMinimum @click.native="minimumToggle"></BtnMinimum>
        <div class="compo-form-name">
            <label class="compo-form-title" :class="[$route.name.match('order') ? 'minimum-hidden' : '']">결제금액</label>
        </div>
        <div class="compo-form-body minimum-target" :class="[$route.name.match('order') ? 'key-value-minimum' : '']">
            <table class="key-value">
                <tr>
                    <th>주문수량</th>
                    <template v-if="productItem.orderCnt">
                        <td>{{productItem.orderCnt}} 건</td>
                    </template>
                    <template v-else>
                        <td>{{this.vuexOrderCnt}} 건</td>
                    </template>
                </tr>
                <tr>
                    <th>주문금액</th>
                    <td>{{goodsPriceMarketCount.toLocaleString()}} 원</td>
                </tr>
                <tr>
                    <th>할인금액</th>
                    <template v-if="calDiscountPrice === 0">
                        <!-- calDiscountPrice값이 0 일 경우 -0으로 출력되기 때문에 .toLocaleString() 제거 -->
                        <td>{{calDiscountPrice}} 원</td>
                    </template>
                    <template v-else>
                        <td>{{calDiscountPrice.toLocaleString()}} 원</td>
                    </template>
                </tr>
            </table>
        </div>
        <div class="key-value-total" :class="[minimumHas && $route.name.match('order') ? 'key-value-minimum' : '']">
            <span class="total-txt">최종 결제금액</span>
            <span class="total-cost"><i>{{totalAccountCount.toLocaleString()}}</i> 원</span>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    components:{
        BtnMinimum: () => import('@/components/tiny-element/BtnMinimum.vue'), // 모바일 하단고정영역 열고 닫기 버튼
    },

    props:{
        productItem : {
            type: Object,
            required: true
        },
    },

    data() {
        return {        
            minimumHas: true, // 하단 영역 최소화 여부
            totalAccount: 0
        }
    },

    computed: {
		...mapState({
            userData: state => state.userData,
            userNo: state => state.userNo,
            vuexOrderCnt: state => state.vuexOrderCnt,
            vuexGoodsPriceMarket: state => state.vuexGoodsPriceMarket,
            vuexGoodsPricePoc: state => state.vuexGoodsPricePoc,
            vuexPayDataItem: state => state.vuexPayDataItem,
        }),
        
        // 정산가 계산
        goodsPriceMarketCount() {
            let priceMarketCount = 0;
            if(this.productItem.orderCnt && this.productItem.goodsPriceMarket) {
                priceMarketCount = Number(this.productItem.orderCnt) * Number(this.productItem.goodsPriceMarket);
            } else {
                priceMarketCount = Number(this.vuexOrderCnt) * Number(this.vuexGoodsPriceMarket);
            }
                
            return Number(priceMarketCount);
        },

        // 할인가 계산
        goodsPricePocCount() {
            let pricePocCount = 0;
            if(this.productItem.orderCnt && this.productItem.goodsPricePoc) {
                pricePocCount = Number(this.productItem.orderCnt) * Number(this.productItem.goodsPricePoc);
            } else {
                pricePocCount = Number(this.vuexOrderCnt) * Number(this.vuexGoodsPricePoc);
            }
            return Number(pricePocCount);
        },

        // 전체 결제금액 계산
        totalAccountCount() {
            let totalAccountResult = 0;
            totalAccountResult = Number(this.goodsPricePocCount);
            this.$store.commit('setVuexTotalAccount', totalAccountResult);
            return totalAccountResult;
        },

        // 할인금액 계산
        calDiscountPrice() {
            let discountPrice = 0;
            if(this.productItem.orderCnt && this.productItem.goodsPriceMarket) {
                discountPrice = Number((this.productItem.goodsPriceMarket - this.productItem.goodsPricePoc) * this.productItem.orderCnt) * -1;
            } else {
                discountPrice = Number((this.vuexGoodsPriceMarket - this.vuexGoodsPricePoc) * this.vuexOrderCnt) * -1;
            }
            return Number(discountPrice);
        }
        
	},

    methods: {
        // 모바일 하단 영역 토글 버튼
        minimumToggle(){
            this.minimumHas ? this.minimumHas = false : this.minimumHas = true;
        },
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/order.scss';

@media (max-width: 1199px) { // only 태블릿 이하 적용
    
    .device-fixed-bottom {
        .compo-form-item{
            margin: 0;
            padding-top: 0;
            overflow: visible;
        }
        .key-value-total {
            position: relative; // .compo-form-body 클래스 영역에 transition 작용시 쌓임맥락의 순위가 높아져 내용이 겹쳐 비추는 현상을 막기 위해 .key-value-total의 쌓임맥락을 높여주기 위한 수단
            background-color: var(--white);
            line-height: 1;
            padding-top: 0;
            padding-bottom: 0;

            .total-cost {
                i {
                    color: var(--primary);
                    font-size: 23px;
                }
            }
        }
    }
    .key-value-minimum { // 주문페이지에서 모바일 태블릿 하단 고정일 때
        margin-top: 0;
        border-width: 0px;
    }
}
</style>